export const TENANT_CREATION_DIALOG = {
  NAME: 'Nombre del Tenant',
  STANDARD: 'Estándares del Tenant',
  DESCRIPTION: 'Descripción',
  CREATE: 'Crear',
  ERROR_CREATING_TENANT: 'Error al crear el tenant',
  TENANT_CREATED_SUCCESSFULLY: 'Tenant creado exitosamente',
}

export const TENANTS = {
  TITLE: 'Tenants',
  SORT: {
    RISK_HIGH: 'Mayor Riesgo',
    RISK_LOW: 'Menor Riesgo',
    PROGRESS_HIGH: 'Mayor Progreso',
    PROGRESS_LOW: 'Menor Progreso',
  },
  RISK_CHART: {
    TITLE: 'Resumen de Riesgo de Tenants',
    DESCRIPTION: 'Puntuaciones de riesgo en tu portafolio de tenants',
    LOW_RISK: 'RIESGO BAJO',
    MEDIUM_RISK: 'RIESGO MEDIO',
    HIGH_RISK: 'RIESGO ALTO',
    RISK_LABEL: 'Riesgo',
    RISK_ZONE_LOW: 'Riesgo Bajo',
    RISK_ZONE_MEDIUM: 'Riesgo Medio',
    RISK_ZONE_HIGH: 'Riesgo Alto',
  },
  RISK_SUMMARY: {
    TITLE: 'Resumen de Riesgo',
    GLOBAL_RISK: 'Riesgo Global',
    COMPLIANCE_STANDARDS: 'Estándares de Cumplimiento',
    OVERALL: 'General',
  },
  TENANT_ITEM: {
    RISK: 'Riesgo',
    NO_STANDARDS: 'Sin estándares configurados',
    CERTIFICATION: 'certificación',
    CERTIFICATIONS: 'certificaciones',
  },
  SNACKBAR: {
    ERROR_SWITCHING: 'Error al cambiar de tenant',
    SWITCHED: 'Tenant cambiado',
  },
  NAV_USER: {
    TENANT: 'Tenant',
    SIMULATED_TENANT: 'Tenant Simulado',
    SWITCH_TENANT: 'Cambiar Tenant',
    LOG_OUT: 'Cerrar sesión',
    LAST_LOGIN: 'Último acceso',
  },
  COMMAND_SEARCH: {
    TITLE: 'Paleta de Comandos',
    PLACEHOLDER: 'Escribe un comando o busca...',
    NO_RESULTS: 'No se encontraron resultados.',
    DESCRIPTION: 'Buscar y ejecutar comandos',
    NAVIGATION: 'Ir a',
  },
}
